export enum BranchAPIKeys {
  BRANCH_TERMS_AND_CONDITIONS = 'branchTermsAndConditions',
}
